
const CreateContentComponent_mutate = `
    mutation createContentComponent(
      $label: String!
      $formId: Int!
      $caption: String
      
      ) {
      createContentComponent(                
        label: $label,
        formId: $formId,
        caption: $caption
        ) {
        component
        {
          componentId
          label
          caption
        }
      }
    }
`;

const EditContentComponent_mutate = `
    mutation editContentComponent(
      $componentId: Int!
      $label: String!
      $caption: String
      ) {
      editContent(
        componentId: $componentId,                
        label: $label,
        caption: $caption) {
        component
        {
          componentId
          label
          caption
        }
      }
    }
`;

module.exports = {  
  
  CREATE_CONTENT_COMPONENT_MUTATION : CreateContentComponent_mutate,
  EDIT_CONTENT_COMPONENT_MUTATION : EditContentComponent_mutate
  
}
